import Typography from '@material-ui/core/Typography'
import React from 'react'

interface IUsernameMessage {
  username: string
  isValid: boolean
  loading: boolean
  successMessage: string
  errorMessage: string
}

export const UsernameMessage = ({
  username,
  isValid,
  loading,
  successMessage,
  errorMessage,
}: IUsernameMessage) => {
  if (loading) {
    return <p>Checking...</p>
  } else if (isValid) {
    return (
      <Typography variant="body2" color="primary" component="p">
        {successMessage}
      </Typography>
    )
  } else if (username && !isValid) {
    return (
      <Typography variant="body2" color="error" component="p">
        {errorMessage}
      </Typography>
    )
  } else {
    return <p></p>
  }
}
